import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'rt-dot',
  template: '',
  styleUrls: ['./dot.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'color() + " " + size()',
    '[class.has-border]': 'hasBorder()',
    '[class.pulse]': 'pulse()',
  },
})
export class DotComponent {
  public readonly color = input<
    'unread' | 'notifications' | 'active' | 'archived' | 'warning-outline' | 'primary' | 'tellent'
  >();
  public readonly hasBorder = input<boolean>(false);
  public readonly size = input<'small' | 'medium' | 'large'>();
  public readonly pulse = input<boolean>(false);
}
